import { gql } from 'apollo-angular';

export const RemoveShareFunnelDocument = gql`
  mutation removeFunnelShare($shareId: Int!) {
    removeFunnelShare(shareId: $shareId)
  }
`;
